import React, { useContext, useEffect } from "react";
import { Route, Switch, BrowserRouter, Redirect } from "react-router-dom";
import {
  Home,
  Login,
  ServerForm,
  ServerStatus,
  Contact,
  ContactForm,
  User,
  UserForm,
} from "./containers";
import { Store } from "./store";
import { MainLayout, Page404 } from "./components";
import { _setToken } from "./services/client";

export function DashBoard() {
  const { state } = useContext(Store);
  const lsuser = localStorage.getItem("monitoring_system");

  if (!state.session && lsuser) {
    return null;
  }

  return (
    <Route
      render={(props) =>
        state.session ? (
          <MainLayout>
            <Switch>
              <Route path={`/`} exact component={Home} />
              <Route path={`/server/list`} exact component={Home} />
              <Route path={`/server/create`} exact component={ServerForm} />
              <Route path={`/server/detail/:id`} component={ServerForm} />
              <Route path={`/server/status/:id`} component={ServerStatus} />
              <Route path={`/contact/list`} component={Contact} />
              <Route path={`/contact/create`} component={ContactForm} />
              <Route path={`/contact/detail/:id`} component={ContactForm} />

              <Route
                path={`/user/list`}
                render={(props) =>
                  state.session.is_admin ? <User {...props} /> : <Page404 />
                }
              />

              <Route
                path={`/user/create`}
                render={(props) =>
                  state.session.is_admin ? <UserForm {...props} /> : <Page404 />
                }
              />

              <Route
                path={`/user/detail/:id`}
                render={(props) =>
                  state.session.is_admin ? <UserForm {...props} /> : <Page404 />
                }
              />
              <Route path={`/`} exact component={Home} />
            </Switch>
          </MainLayout>
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
}

export const HomeRoutes = () => {
  const { state } = useContext(Store);
  return (
    <BrowserRouter>
      <Route path="/" component={DashBoard} />
      <Route
        path={`/login`}
        render={(props) =>
          state.session ? <Redirect to="/server/list" /> : <Login {...props} />
        }
      />
    </BrowserRouter>
  );
};

function App() {
  const { state, dispatch } = useContext(Store);
  const lsuser = localStorage.getItem("monitoring_system");
  useEffect(() => {
    if (lsuser) {
      const user = JSON.parse(lsuser);
      _setToken(user.token);
      dispatch({
        type: "SET_SESSION",
        payload: user,
      });
    }
  }, []);
  return <HomeRoutes />;
  //return state.session ? <HomeRoutes /> : <Login />;
}

export default App;
